export default "__VITE_ASSET__DpQ0HOK4__"